import React from 'react';
import NumberInput from './NumberInput';
import BigNumber from 'bignumber.js';

/**
 * IntegerInput - specialized component for integer input
 * Wraps NumberInput but ensures no decimal fractions and step of 1
 */
const IntegerInput = (props) => {
    // Handle value change to remove decimal part
    const handleIntegerChange = (value) => {
        if (value && value instanceof BigNumber) {
            // Round to integer
            const intValue = value.integerValue(BigNumber.ROUND_HALF_UP);
            props.onChange(intValue);
        } else {
            props.onChange(value);
        }
    };

    return (
        <NumberInput
            {...props}
            decimals={0}
            step={1}
            onChange={handleIntegerChange}
            // Force disable decimal format
            formatOptions={{
                forceIntegerDisplay: true
            }}
        />
    );
};

export default IntegerInput; 